import {
  Box,
  Button,
  Container,
  Paper,
  Modal,
  Typography,
  TextField,
  CircularProgress,
  Grid,
} from '@mui/material';
import { useFormik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { updateLastActive, validateEmial } from '../../utils/templatesApi';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const Validation = ({ userId, setRender }) => {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [validEmail, setValidEmail] = React.useState('');

  const isInvalid = validEmail?.status !== 'valid';
  const isValid = validEmail?.status === 'valid';

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
    updateLastActive(userId, new Date())
  }

  const validationSchema = yup.object({
    email: yup
      .string()
      .required('Email is required')
      .email('Invalid email format'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      updateLastActive(userId, new Date())
      const repsonse = await validateEmial(userId, values.email);
      setValidEmail(repsonse?.data?.validationResponse);
      if (repsonse?.data?.validationResponse.status === 'valid') {
        resetForm();
        handleOpen();
        setLoading(false);
        setRender((prev) => !prev);
      } else {
        resetForm();
        handleOpen();
        setLoading(false);
        setRender((prev) => !prev);
      }
      setLoading(false);
    },
  });

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '5vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Container maxWidth="lg" sx={{ minWidth: '80vw', marginBottom: 3 }}>
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            noValidate
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 2,
              paddingTop: 6,
              alignItems: 'center', // ✅ This vertically aligns children
            }}
          >
            <TextField
              name="email"
              label="Email"
              margin="normal"
              sx={{ height: '55px', width: '400px' }}
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              helperText={formik.touched.email && formik.errors.email}
              error={formik.touched.email && Boolean(formik.errors.email)}
            />
            <Button
              type="submit"
              variant="contained"
              sx={{
                textTransform: 'capitalize',
                height: '50px',
                width: '120px',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mt: 1,
                backgroundColor: '#111827',
              }}
            >
              Validate
            </Button>
          </Box>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Paper elevation={3} sx={style}>
              <CloseIcon
                sx={{
                  position: 'absolute',
                  top: 20,
                  right: 30,
                  fontSize: '40px',
                  cursor: 'pointer',
                }}
                onClick={handleClose}
              />

              <EmailIcon
                sx={{
                  fontSize: 40,
                  marginRight: 1,
                  textAlign: 'center',
                  width: '100%',
                }}
              />
              <Grid
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    width: '70%',
                    backgroundColor: '#f0f0f0',
                    padding: 2,
                    textAlign: 'center',
                  }}
                >
                  {validEmail.address}
                </Typography>
              </Grid>

              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '2rem',
                  alignItems: 'center',
                  mt: 4,
                }}
              >
                <TextField
                  name="STATUS"
                  label="STATUS"
                  margin="normal"
                  value={validEmail.status || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                        color: 'inherit',
                      },
                    },
                  }}
                  sx={{
                    width: '200px',
                    backgroundColor: isInvalid
                      ? '#ffe6e6' // light red
                      : isValid
                        ? '#e6ffe6' // light green
                        : 'transparent',
                    // Override the label color
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: isInvalid
                          ? 'red'
                          : isValid
                            ? 'green'
                            : undefined,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: isInvalid
                          ? 'red'
                          : isValid
                            ? 'green'
                            : undefined,
                      },
                    },
                    // Remove focus outline
                    '& .MuiInputBase-input:focus': {
                      outline: 'none',
                    },
                  }}
                />

                <TextField
                  name="SUB-STATUS"
                  label="SUB-STATUS"
                  margin="normal"
                  value={validEmail.sub_status || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                        color: 'inherit',
                      },
                    },
                  }}
                  sx={{
                    width: '200px',
                    backgroundColor: isInvalid
                      ? '#ffe6e6' // light red
                      : isValid
                        ? '#e6ffe6' // light green
                        : 'transparent',
                    // Override the label color
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: isInvalid
                          ? 'red'
                          : isValid
                            ? 'green'
                            : undefined,
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: isInvalid
                          ? 'red'
                          : isValid
                            ? 'green'
                            : undefined,
                      },
                    },
                    // Remove focus outline
                    '& .MuiInputBase-input:focus': {
                      outline: 'none',
                    },
                  }}
                />
                <TextField
                  name="FREE EMAIL"
                  label="FREE EMAIL"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },

                    },

                  }}
                  value={validEmail.free_email || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '2rem',
                  alignItems: 'center',
                }}
              >
                <TextField
                  name="DID YOU MEAN"
                  label="DID YOU MEAN"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.did_you_mean || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="ACCOUNT"
                  label="ACCOUNT"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.account || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="DOMAIN"
                  label="DOMAIN"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.domain || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '2rem',
                  alignItems: 'center',
                }}
              >
                <TextField
                  name="DOMAIN AGE DAYS"
                  label="DOMAIN AGE DAYS"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.domain_age_days || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="SMTP PROVIDER"
                  label="SMTP PROVIDER"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.smtp_provider || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="MX FOUND"
                  label="MX FOUND"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.mx_found || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '2rem',
                  alignItems: 'center',
                }}
              >
                <TextField
                  name="MX RECORD"
                  label="MX RECORD"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.mx_record || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="FIRST NAME"
                  label="FIRST NAME"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.firstnam || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
                <TextField
                  name="LAST NAME"
                  label="LAST NAME"
                  margin="normal"
                  sx={{
                    width: '200px',
                    '& .MuiInputLabel-root': {
                      color: 'black',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset, &.Mui-focused fieldset': {
                        borderColor: '#e0e0e0',
                      },
                    },
                  }}
                  value={validEmail.lastname || 'Unknown'}
                  InputProps={{
                    readOnly: true,
                    sx: {
                      input: {
                        height: '10px',
                      },
                    },
                  }}
                />
              </Grid>
            </Paper>
          </Modal>
        </Container>
      )}
    </>
  );
};

export default Validation;
